import { updateObjectValues } from '@/utils/helpers';
import { MARKET_DATA_MAP, MY_SHARES_MARKET_DATA_MAP, CONTRACT_DATA_MAP } from '@/services/notifications/proxy';

export const updateMarket = (market, data) => {
  if (market.marketId === data.MarketId) {
    return updateObjectValues(market, data, MARKET_DATA_MAP);
  }
  return market;
};

export const updateContract = (contract, data) => {
  if (contract.contractId === data.ContractId) {
    return updateObjectValues(contract, data, CONTRACT_DATA_MAP);
  }
  return contract;
};

export const updateMarketContracts = (market, data) => {
  if (market.contracts) {
    market.contracts = market.contracts.map(contract => updateContract(contract, data));
    // CONTRACTS SORT
    // market.contracts.sort((prev, next) => {
    //   if (prev.lastTradePrice < next.lastTradePrice) {
    //     return 1;
    //   } else if (prev.lastTradePrice > next.lastTradePrice) {
    //     return -1;
    //   }
    //   return 0;
    // });
  }
  if (market.marketContracts) {
    market.marketContracts = market.marketContracts.map(contract => updateContract(contract, data));
    // CONTRACTS SORT
    // market.marketContracts.sort((prev, next) => {
    //   if (prev.lastTradePrice < next.lastTradePrice) {
    //     return 1;
    //   } else if (prev.lastTradePrice > next.lastTradePrice) {
    //     return -1;
    //   }
    //   return 0;
    // });
  }
  return market;
};

export const updateMySharesMarket = (market, data) => {
  if (market.marketId === data.MarketId) {
    return updateObjectValues(market, data, MY_SHARES_MARKET_DATA_MAP);
  }
  return market;
};



// WEBPACK FOOTER //
// ./src/utils/notifications.js